<template>
  <DirectionsUniversity />
</template>

<script>
import DirectionsUniversity from '@/components/admin/recommendations/DirectionsUniversity.vue'

export default {
  name: 'AdministrationDirectionsUniversity',
  components: { DirectionsUniversity }
}
</script>

<style scoped>

</style>
